<!-- Filter By Label -->
<div class="analyses-header fw-filter-box animated fadeIn">
  <div class="analyses-filter">
    <mat-form-field appearance="outline">
      <input
        data-id="analyses-tab-filter"
        [formControl]="labelFilter"
        matInput
        [placeholder]="'analyses.labels.filterByLabel' | translate">
    </mat-form-field>
  </div>
  <div class="analyses-header-spacer"></div>
  <div *ngIf="levels?.length > 0" class="analyses-filter">
    <mat-form-field appearance="outline">
     <mat-select
      test-id="level-filter"
      [formControl]="levelFilter"
      [placeholder]="'analyses.labels.filterByLevel' | translate"
      multiple>
       <mat-option *ngFor="let level of levels" [value]="level">
         {{ level }}
       </mat-option>
     </mat-select>
    </mat-form-field>
  </div>
  <div class="analyses-header-spacer"></div>
  <div>
    <button
      test-id="run-gear"
      *ngIf="canRunGear"
      mat-flat-button color="primary"
      (click)="runAnalysisGear()">
      {{ 'analyses.labels.runAnalysesGear' | translate}}
    </button>
  </div>
</div>

<!-- Analyses -->
<ng-container *ngIf="analyses$ | async as analyses; else loadingState">
  <ng-container *ngIf="analyses?.length > 0; else emptyState">

    <analysis-results
      *ngFor="let analysis of analyses"
      [analysis]="analysis"
      [container]="container"
      (afterDelete)="refreshAnalyses()"
      class="analysis-result">
    </analysis-results>

    <button type=button mat-button
      *ngIf="analyses?.length < total"
      (click)="nextPage()"
      style="width:100%">
      Load More
    </button>

  </ng-container>
</ng-container>

<!-- Loading State -->
<ng-template #loadingState>
  <div class="blank-state">
    <img src="/assets/images/loading.svg" style="margin-bottom:10px">
    <p>Loading analyses...</p>
  </div>
</ng-template>

<!-- Blank State -->
<ng-template #emptyState>
  <div class="blank-state">
    <fw-icon size="large" color="slate">settings-gear</fw-icon>
    <p>No analyses have run!</p>
    <button type="button" (click)="refreshAnalyses()" class="btn btn-primary">Refresh</button>
  </div>
</ng-template>
